import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Space } from 'antd'
import { LightThemeProvider } from '@qflow/theme'

import { Readings } from 'portal/components/Utilities'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'
import { projectUsersLoad } from 'portal/store/projectUsers/actions'

export const ReadingsPage = () => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams()

  // Load Project Users in to Redux state
  useEffect(() => {
    dispatch(projectUsersLoad(accountId, projectId, false))
  }, [accountId, dispatch, projectId])

  return (
    <PageContainer id="Readings" style={{ paddingBottom: '0' }}>
      <LightThemeProvider>
        <Sidebar />
        <Space direction="vertical" size="middle">
          <Readings />
        </Space>
      </LightThemeProvider>
    </PageContainer>
  )
}
